import {useParams} from 'react-router-dom';

import {useProjectParams} from '../../pages/ProjectPage/useProjectParams';
import {getNwIdSearchString} from '../../state/workspaces/url';
import * as urls from '../../util/urls';

export function useRunDetailsTo(
  runName: string,
  givenProject?: {entityName: string; name: string}
) {
  // TODO(react-compiler): reads window.location during render; compiled output
  // would cache it.
  'use no memo';
  const urlProject = useProjectParams();
  const entityName = givenProject?.entityName ?? urlProject.entityName;
  const projectName = givenProject?.name ?? urlProject.projectName;

  const {groupName, sweepName} = useParams<{
    groupName?: string;
    sweepName?: string;
  }>();

  let baseProjectUrl: string;
  if (groupName) {
    baseProjectUrl = urls.runGroup({entityName, projectName, name: groupName});
  } else if (sweepName) {
    baseProjectUrl = urls.sweep({entityName, projectName, sweepName});
  } else {
    baseProjectUrl = urls.project({entityName, name: projectName});
  }

  const nwId = getNwIdSearchString();

  return (tab?: string) => ({
    pathname: `${baseProjectUrl}/runs/${runName}${tab ? `/${tab}` : ''}`,
    search: nwId,
  });
}
